import React from "react";

const AadLogo: React.FC = () => (
  <svg
    width="37"
    height="26"
    viewBox="0 0 37 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6237 8.92816V15.8391H10.4225L13.6237 8.92816ZM32.0121 8.92816V15.8391H28.8109L32.0121 8.92816ZM30.337 0L18.6117 25.5144V0H11.9115L0 26H5.76962L8.04024 21.069H13.6237V26H24.1579L26.4286 21.069H32.0121V26H37V0H30.337Z"
      fill="black"
    />
  </svg>
);
export default AadLogo;
